import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import { IFormAgeOfMajority18 } from "../Models/Forms/IFormAgeOfMajority18";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';

@Injectable()
export class FormAgeOfMajority18Service extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormAgeOfMajority18(id: number) {
    return this._http.get(this._baseUrl + "api/FormAgeOfMajority18/" + id)
      .map((response: IFormAgeOfMajority18) => response as IFormAgeOfMajority18)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormAgeOfMajority18/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  insertUpdateFormAgeOfMajority18(formAgeOfMajority18Details: IFormAgeOfMajority18) {
    return this._http.post(this._baseUrl + 'api/FormAgeOfMajority18', formAgeOfMajority18Details)
      .map((response: IFormAgeOfMajority18) => response as IFormAgeOfMajority18)
      .catch(this.errorHandler);
  }

  deleteAgeOfMajority18(id) {
    return this._http.delete(this._baseUrl + "api/FormAgeOfMajority18" + id)
      .map((response: IFormAgeOfMajority18) => response as IFormAgeOfMajority18)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}
  
